PJQ.views.settings.TermsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Terms')
    },
    events: {
        'click .edit-terms': 'editTermsClicked',
        'click .delete-terms': 'deleteTermsClicked',
        'click .add-terms': 'addTermsClicked'
    },
    beforeFirstRender: function () {
        this.context = this.options.context.toLowerCase();
       if(this.context && !this.collection){
           switch(this.context) {
               case 'commitments':
                   PJQ.app.session.fetchCommitmentTerms(_.bind(function(termsCollection){
                       this.collection = termsCollection;
                       this.render();
                   }, this));
                   break;
               case 'contracts':
                   PJQ.app.session.fetchPrimeContractTerms(_.bind(function(termsCollection){
                       this.collection = termsCollection;
                       this.render();
                   }, this));
           }
       }
    },
    renderData: function () {
        return {

        };
    },
    afterRender: function () {
        if(this.collection) {
            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$(".terms-table"),
                data: this.collection.models,
                rowId: "cid",
                order: [0, 'asc'],
                language: {
                    zeroRecords: 'Click "Add Terms" to create new terms'
                },
                pageLength: 50,
                isHideSearch: true,
                bSort: false,
                onRowDoubleClick: _.bind(function (row) {
                    this.editTerms(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: _.bind(function (row) {
                                this.editTerms(row.data());
                            }, this)
                        },
                        {
                            name: 'Delete',
                            isDanger: true,
                            onClick: _.bind(function (row) {
                                this.deleteGroup(row);
                            }, this)

                        }
                    ]
                },
                columns: [
                    {
                        "title": "Name",
                        "data": "attributes.name",
                        "orderable": true
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "searchable": false,
                        "width": "80px",
                        "render": _.bind(function (data, type, row) {
                            return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-terms ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-terms ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                        }, this)
                    }
                ]
            });
        }
    },
    addTermsClicked: function(e){
        let newTerm = new this.collection.model({
            name: '',
            type: this.context,
            terms: '',
            isDefault: false
        });

        this.editTerms(newTerm);
    },
    editTermsClicked: function(e){
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editTerms(row.data());
    },
    editTerms: function (terms) {
        new PJQ.views.settings.EditTermsModal({
            model: terms,
            onSave: _.bind(function (model) {
                if (model.hasChanged() || model.isNew()) {
                    if (model.isNew()) {
                        this.collection.add(model);
                        this.dataTable.addRow(model);
                    }
                    model.save(null, {
                        notify: true,
                        success: _.bind(function(){
                            if(model.get('isDefault')){
                                _.each(this.collection.models, function(term){
                                    if(term !== model){
                                        term.set('isDefault', false);
                                    }
                                }, this)
                            }
                        }, this)
                    });
                    this.dataTable.refresh();
                }
            }, this),
            onDelete: _.bind(function(model){
                if (model.id > 0) {
                    let row = this.dataTable.getRow(model.cid);
                    this.collection.remove(model);
                    model.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        })
    },
    deleteTermsClicked: function(e){
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteTerms(row);
    },
    deleteTerms: function(row){
        let terms = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete these terms?",
            onDelete: _.bind(function () {
                this.collection.remove(terms);
                terms.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.EditTermsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Terms'),
        maxWidth: 650
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'delete',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.termsEditor = new PJQ.inputs.HTMLEditor({
            el: this.$('.terms-editor'),
            editorHeight: 150,
            isHideTokens: true,
            defaultValue: this.model.get('terms'),
            onChange: _.bind(function (contents) {
                this.model.set('terms', contents);
            }, this)
        });
    },
    close: function () {
        this.removeModal()
    },
    save: function () {
        if(typeof this.options.onSave === "function"){
            this.options.onSave(this.model);
        }
        this.removeModal();
    },
    delete: function(){
        if(typeof this.options.onDelete === 'function'){
            this.options.onDelete(this.model);
        }
        this.removeModal();
    }
});